import {useState} from 'react'
import { useParams } from 'react-router-dom'
import {ROUTES} from "../config/constants"
import {formatDecimalsAfterDot} from './validation'

export const DEMO_CALC_ID = '0001186'

export const isDemoPage = () => window.location.pathname.replace(/\/$/, '') === ROUTES.DEMO

export const useGetCalcIdFromRoute = () => {
  const params = useParams()

  if (isDemoPage()) {
    return DEMO_CALC_ID
  }

  return params?.id ?? ''
}

export const getDecimalInputValue = (
  rawValue: string | number | undefined,
  isEditing: boolean,
  decimals = 2
) => {
  if (rawValue === null || rawValue === undefined || rawValue === '') {
    return '';
  }

  const normalizedValue = String(rawValue).replace(',', '.');

  if (isEditing) {
    return normalizedValue.replace('.', ',');
  }

  const formattedValue = formatDecimalsAfterDot(normalizedValue, decimals);

  return (formattedValue ?? normalizedValue).replace('.', ',');
}

export const useFormattedDecimalInput = () => {
  const [ editingField, setEditingField ] = useState<string>();

  const getDisplayValue = ({
    fieldName,
    rawValue,
    decimals = 2
  }: DecimalInputDisplayParams) => {
    const isCurrentField = editingField === fieldName;

    return getDecimalInputValue(rawValue, isCurrentField, decimals);
  }

  const startEditing = (fieldName: string) => {
    setEditingField(fieldName);
  }

  const stopEditing = (fieldName: string) => {
    setEditingField(currentField => currentField === fieldName ? undefined : currentField);
  }

  return {
    getDisplayValue,
    startEditing,
    stopEditing,
  };
}
